/**
 * Central configuration. Bump MODEL_VERSION when Alfredo's next Roboflow training
 * finishes; everything else stays put.
 */
export const config = {
    /** Roboflow project slug. */
    project: "pruneit",
    /** Roboflow model version. Update when a new version is trained. */
    modelVersion: 8,
    /**
     * URL of the Cloudflare Worker that proxies Roboflow.
     * In dev, this can be left as /api and routed via vite proxy.
     * In prod, replace with the deployed worker URL.
     */
    inferenceProxyUrl: import.meta.env.VITE_INFERENCE_PROXY_URL ?? (import.meta.env.DEV ? "/api/infer" : "https://pruneit-inference-proxy.pruneit.workers.dev"),
    /** Default confidence threshold for displaying detections (0-100). */
    confidenceThreshold: 47,
    /** Max longest-edge pixels for uploaded image (reduces network + API cost). */
    maxUploadDimension: 1600,
    /** Per-class overlay colors. Keys are Roboflow class names. */
    classColors: {
        "One year old": "#4ade80", // green — preserve for production
        "Two year old": "#facc15", // yellow
        "Three year old": "#dc2626", // red-brown
        Support: "#94a3b8", // gray — ignore
    },
    /** Fallback color for unrecognized classes. */
    unknownClassColor: "#a855f7",
};
